import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Fade from "@mui/material/Fade";
import DateDropdown from "../../asset/Images/Icons/DateDropdownIcon.svg";
import { yearState } from "../../atom";
import { useRecoilState } from "recoil";

export default function SelectYearDropdown({ setSearch }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [year, setYear] = useRecoilState(yearState);
  const [selectedYear, setSelectedYear] = React.useState(year);
  const open = Boolean(anchorEl);

  React.useEffect(() => {
    console.log("Year setSearch called with:", "2024");
    setSearch(year);
  }, [setSearch]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (year) => {
    setAnchorEl(null);
    if (year) {
      setSelectedYear(year);
      console.log("Year handleClose called with:", year);
      setSearch(year);
      setYear(year);
    }
  };

  const menuItemStyle = {
    fontFamily: "GmarketSansLight",
    fontSize: "18px",
    width: "200px",
    height: "39px",
    "&:hover": {
      backgroundColor: "#E7F0FF",
    },
  };

  const options = ["2022", "2023", "2024"];

  return (
    <div>
      <Button
        id="fade-button"
        aria-controls={open ? "fade-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          color: "black",
          fontSize: "22px",
          fontFamily: "GmarketSansLight",
        }}
      >
        {selectedYear}년
        <img src={DateDropdown} alt="" />
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          "aria-labelledby": "fade-button",
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose()}
        TransitionComponent={Fade}
        PaperProps={{
          sx: { borderRadius: "10px" },
        }}
      >
        {options.map((option) => (
          <MenuItem key={option} sx={menuItemStyle} onClick={() => handleClose(option)}>
            {option + "년"}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
